import { Component, OnInit } from '@angular/core';
import { ScreeningPageComponent } from 'libs/shared/src/lib/page/screening/screening.component';

@Component({ standalone: false, selector: 'app-page-screening', templateUrl: './screening.component.html' })
export class CustomScreeningPageComponent extends ScreeningPageComponent {}
